import { computed, ref } from '@vue/composition-api'
import { defineStore } from 'pinia'

export const useBetslipBetBuilderStore = defineStore('betslipBetBuilder', () => {
  const betBuilderLoadingMap = ref({})
  const isLoadingBetBuilder = computed(() => {
    const arr = Object.values(betBuilderLoadingMap.value)
    return arr.length > 0 && arr.some((x) => x.loading)
  })

  const setBetBuilderSize = (id, size = 0, uniqId) => {
    const targetLoading = betBuilderLoadingMap.value[id] || {}
    betBuilderLoadingMap.value[id] = { uniqId, ...targetLoading, size }
    betBuilderLoadingMap.value = { ...betBuilderLoadingMap.value }
  }

  const setBetBuilderLoading = (id, loading = false, uniqId) => {
    const targetLoading = betBuilderLoadingMap.value[id] || {}
    if (targetLoading.loading !== loading) {
      betBuilderLoadingMap.value[id] = { uniqId, ...targetLoading, loading }
      betBuilderLoadingMap.value = { ...betBuilderLoadingMap.value }
    }
  }

  const removeBetBuilderLoading = (id) => {
    delete betBuilderLoadingMap.value[id]
    betBuilderLoadingMap.value = { ...betBuilderLoadingMap.value }
  }

  return {
    betBuilderLoadingMap,
    isLoadingBetBuilder,
    setBetBuilderSize,
    setBetBuilderLoading,
    removeBetBuilderLoading
  }
})
